import { AGENTIC_CHAT_MODES } from "./constants.js";

/** Recent Activity and ledger lines use the same strings as the chat composer mode switcher. */
export function getAgenticChatModeLedgerLargeText(chatMode) {
  if (chatMode === "chat") {
    return AGENTIC_CHAT_MODES.find((m) => m.value === "chat")?.label ?? "Chat only";
  }
  if (chatMode === "write") {
    return AGENTIC_CHAT_MODES.find((m) => m.value === "write")?.label ?? "Allow edits";
  }
  return null;
}
